// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "src/assets/css/" + chunkId + "." + {"394":"331f020f","478":"aafa9586","658":"331f020f","677":"331f020f","965":"331f020f"}[chunkId] + ".css";
};